// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack.classic.js, новая — rack.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack.classic';
import * as cp from './rack.cp';

export default isCp ? cp.default : classic.default;
